<template>
  <div class="index-welfare container">
    <div class="container-head">
      <div class="head-left">
        <div class="icon">
          <img src="../../static/index/welfare/welfare-icon.png" />
        </div>
        新人福利专区
      </div>
    </div>
    <div class="welfare-list">
      <div class="row">
        <div
          class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
          v-for="item in welfare_list"
          :key="item.id"
          :data-id="item.id"
          @click="goreceive"
        >
          <div class="welfare-item">
            <div class="item-price">
              {{ item.discountValue }}<span>￥</span>
            </div>
            <div class="item-info">
              <div class="info-1">{{ item.title }}</div>
              <div class="info-2">{{ item.subtitle }}</div>
            </div>
            <div class="welfare-button">
              <span>立即<br />领取</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getreceivecoupon } from "../view/api/api"; //引入api里面定义的方法
export default {
  props: ["welfare_list"],
  data() {
    return {};
  },
  methods: {
    async goreceive(e) {
      //console.log(e);
      var _self = this;
      var id = e.currentTarget.dataset.id;
      var data = {
        uid: localStorage.getItem("userId"),
        couponid: id
      };
      //console.log(data);
      const res = await getreceivecoupon(data);
      //console.log(res);
      if (res.status == 1) {
        this.$toast({
          type: "success",
          message: "领取成功!"
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.index-welfare {
  flex-direction: column;
  margin: auto;

  .welfare-title {
    width: 100%;
    font-size: 0.32rem;
    height: 0.32rem;
    line-height: 0.32rem;
    background: url(../../static/index/welfare/welfare-icon.png) center left
      no-repeat;
    background-size: 36px 32px;
    padding-left: 0.4rem;
    margin-bottom: 0.3rem;
  }

  .welfare-list {
    flex-direction: column;

    .welfare-item {
      width: 100%;
      height: 1.28rem;
      background: url(../../static/index/welfare/welfare-item-bg.png) no-repeat;
      background-size: 100%;
      flex-direction: row;
      align-items: center;
      display: flex;

      .item-price {
        color: #ff545a;
        font-size: 0.6rem;
        line-height: 0.6rem;
        margin-right: 0.1rem;
        margin-left: 0.45rem;

        span {
          font-size: 0.3rem;
          line-height: 0.6rem;
        }
      }

      .item-info {
        flex-direction: column;
        justify-content: center;
        text-align: center;
        color: #cd7420;
        width: 2.1rem;
        margin-right: 0.4rem;

        .info-1 {
          font-size: 0.24rem;
          line-height: 0.33rem;
          margin-bottom: 0.06rem;
        }

        .info-2 {
          font-size: 0.18rem;
          line-height: 0.25rem;
        }
      }

      .welfare-button {
        width: 0.86rem;
        height: 0.86rem;
        background: url(../../static/index/welfare/welfare-item-button.png)
          no-repeat;
        background-size: 100%;
        color: #ffffff;
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        font-size: 0.24rem;
        line-height: 0.25rem;
        cursor: pointer;
      }
    }
    @media (max-width: 991px) {
      .welfare-item {
        width: 6.86rem;
        height: 1.49rem;
        background: url(../../static/index/welfare/welfare-item-bg.png)
          no-repeat;
        background-size: 100%;
        flex-direction: row;
        align-items: center;
        margin-bottom: 0.3rem;
        padding: 0 0.5rem;

        .item-price {
          font-size: 0.6rem;
          line-height: 0.6rem;
          color: #ff545a;
          margin-right: 0.3rem;
          margin-left: 0;

          text {
            font-size: 0.4rem;
            line-height: 0.6rem;
          }
        }

        .item-info {
          flex-direction: column;
          justify-content: center;
          text-align: center;
          color: #cd7420;
          width: 2.61rem;
          margin-right: 0.56rem;

          .info-1 {
            font-size: 0.3rem;
            font-weight: bold;
          }

          .info-2 {
            font-size: 0.24rem;
          }
        }

        .welfare-button {
          width: 1rem;
          height: 1rem;
          background: url(../../static/index/welfare/welfare-item-button.png)
            no-repeat;
          background-size: 100%;
          color: #ffffff;
          text-align: center;
          align-items: center;
          justify-content: center;
          font-size: 0.24rem;
          font-weight: bolder;
        }

        &::last-child {
          margin-bottom: 0rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexwelfare.vue